function checkCheckoutButtonState() {
  // Only cart checkout buttons — never product-page Buy it now
  const checkoutButtons = document.querySelectorAll(
    '#checkout, #CartDrawer-Checkout, .cart__checkout-button, cart-drawer button[name="checkout"], #main-cart-footer button[name="checkout"]'
  );

  const liveTotalEl = document.querySelector('[data-cart-total-cents]');
  if (liveTotalEl) {
    const parsed = Number(liveTotalEl.dataset.cartTotalCents);
    if (!Number.isNaN(parsed)) {
      window.cartTotalCents = parsed;
    }
  }

  const cartTotal = window.cartTotalCents || 0;
  const minOrder = window.minOrderCents || 0;

  checkoutButtons.forEach((button) => {
    if (button.closest('.buy-it-now-min-order, .shopify-payment-button, shopify-accelerated-checkout')) {
      return;
    }

    if (cartTotal < minOrder) {
      button.disabled = true;
      button.style.pointerEvents = 'none';
      button.style.opacity = '0.5';
    } else {
      button.disabled = false;
      button.style.pointerEvents = '';
      button.style.opacity = '';
    }
  });
}

function syncCartTotalCents(cartData) {
  if (cartData && typeof cartData.total_price === 'number') {
    window.cartTotalCents = cartData.total_price;
    checkCheckoutButtonState();
    return;
  }

  const cartJsUrl = window.routes?.cart_url ? `${window.routes.cart_url}.js` : '/cart.js';
  fetch(cartJsUrl)
    .then((response) => response.json())
    .then((cart) => {
      if (typeof cart.total_price === 'number') {
        window.cartTotalCents = cart.total_price;
        checkCheckoutButtonState();
      }
    })
    .catch(() => {});
}

function parseBuyItNowVariantPrices(root) {
  if (!root || !root.querySelector) return null;
  const script = root.querySelector('.buy-it-now-variant-prices');
  if (!script) return null;
  try {
    return JSON.parse(script.textContent);
  } catch (e) {
    return null;
  }
}

function unitPriceForQuantity(variantData, quantity) {
  if (!variantData) return 0;
  let price = Number(variantData.price) || 0;
  const breaks = Array.isArray(variantData.breaks) ? variantData.breaks.slice() : [];
  breaks.sort((a, b) => Number(b.qty) - Number(a.qty));
  for (const priceBreak of breaks) {
    if (quantity >= Number(priceBreak.qty)) {
      price = Number(priceBreak.price) || price;
      break;
    }
  }
  return price;
}

function getProductPageQuantity(wrapper) {
  const root = wrapper.closest('product-info') || wrapper.closest('.product') || document;
  const candidates = root.querySelectorAll('input.quantity__input, input[name="quantity"]');

  for (const input of candidates) {
    if (input.closest('cart-drawer, cart-items, .cart-item, quick-order-list')) continue;
    const value = parseInt(input.value, 10);
    if (!Number.isNaN(value) && value > 0) return value;
  }

  return 1;
}

function getBuyItNowLineTotalCents(wrapper) {
  const productFormEl = wrapper.closest('product-form');
  const formEl = wrapper.closest('form') || productFormEl?.querySelector('form');
  const productInfo = wrapper.closest('product-info');

  const variantIdInput =
    formEl?.querySelector('input[name="id"]') ||
    productFormEl?.querySelector('input[name="id"]') ||
    productInfo?.querySelector('input.product-variant-id') ||
    document.querySelector('product-info input.product-variant-id');

  const quantity = getProductPageQuantity(wrapper);
  const variantId = String(variantIdInput?.value || wrapper.dataset.variantId || '');

  const prices =
    parseBuyItNowVariantPrices(wrapper.parentElement) ||
    parseBuyItNowVariantPrices(productFormEl) ||
    parseBuyItNowVariantPrices(productInfo) ||
    parseBuyItNowVariantPrices(document);

  const variantData = prices ? prices[variantId] || prices[String(variantId)] : null;
  let unitPrice = variantData ? unitPriceForQuantity(variantData, quantity) : 0;

  // Fallbacks if JSON lookup fails
  if (!unitPrice) {
    unitPrice = Number(wrapper.dataset.unitPriceCents) || 0;
  }
  if (!unitPrice && window.__buyItNowVariantPriceCents) {
    unitPrice = Number(window.__buyItNowVariantPriceCents) || 0;
  }

  const total = unitPrice * quantity;
  wrapper.dataset.lineTotalCents = String(total);
  wrapper.dataset.lineQuantity = String(quantity);
  wrapper.dataset.lineUnitPriceCents = String(unitPrice);
  return total;
}

function setBuyItNowEnabled(wrapper, enabled) {
  // Only flip the data attribute — CSS shows/hides the real vs fake button.
  // Do not disable or style Shopify's payment button (that breaks Buy it now).
  wrapper.dataset.meetsMin = enabled ? 'true' : 'false';
}

function checkBuyItNowButtonState() {
  const wrappers = document.querySelectorAll('.buy-it-now-min-order');
  if (!wrappers.length) return;

  wrappers.forEach((wrapper) => {
    const minOrder = Number(wrapper.dataset.minOrderCents) || window.minOrderCents || 0;
    const lineTotal = getBuyItNowLineTotalCents(wrapper);
    setBuyItNowEnabled(wrapper, lineTotal >= minOrder);
  });
}

function bindBuyItNowMinOrderListeners() {
  document.addEventListener('change', (event) => {
    if (
      event.target.matches(
        'input.quantity__input, input[name="quantity"], input.product-variant-id, input[name="id"]'
      )
    ) {
      checkBuyItNowButtonState();
    }
  });

  document.addEventListener('input', (event) => {
    if (event.target.matches('input.quantity__input, input[name="quantity"]')) {
      checkBuyItNowButtonState();
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.quantity__button')) {
      setTimeout(checkBuyItNowButtonState, 0);
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event?.data?.variant;
      document.querySelectorAll('.buy-it-now-min-order').forEach((wrapper) => {
        if (variant?.id) wrapper.dataset.variantId = String(variant.id);
        if (typeof variant?.price === 'number') {
          wrapper.dataset.unitPriceCents = String(variant.price);
          window.__buyItNowVariantPriceCents = variant.price;
        }
      });
      checkBuyItNowButtonState();
    });
  }
}

checkCheckoutButtonState();
checkBuyItNowButtonState();
bindBuyItNowMinOrderListeners();
setInterval(() => {
  checkCheckoutButtonState();
  checkBuyItNowButtonState();
}, 500);

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    syncCartTotalCents(event?.cartData);
  });
}

// Menu
const items = document.querySelectorAll('.header__inline-menu details');

items.forEach((item) => {
  const menu = item.querySelector('ul');

  item.addEventListener('mouseover', () => {
    item.setAttribute('open', '');

    if (menu) {
      menu.addEventListener(
        'mouseleave',
        () => {
          item.removeAttribute('open');
        },
        { once: true }
      );
    }
  });

  item.addEventListener('mouseleave', () => {
    item.removeAttribute('open');
  });
});
